// Date/time conversion utilities.
// The backend returns timestamps in UTC (ISO strings with an explicit timezone),
// so they are converted to the device's local time here for display.

const EMPTY = '-';

export const formatDateTime = (iso) => (iso ? new Date(iso).toLocaleString() : EMPTY);

export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString() : EMPTY);

export const formatTime = (iso) => (iso ? new Date(iso).toLocaleTimeString() : EMPTY);
